(function () {
  'use strict';

  var MAX_PRODUCTS = 6;
  var FETCH_LIMIT = 10;
  var CONTAINER_ID = 'cart-drawer-recommendations';

  var cachedProducts = [];
  var cachedBadgeData = {};
  var lastProductIds = '';
  var isLoading = false;
  var drawerObserver = null;

  /**
   * Shopify-standard money formatter (prices in cents)
   */
  function formatMoney(cents, moneyFormat) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    cents = parseInt(cents, 10) || 0;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimal = typeof decimal === 'undefined' ? '.' : decimal;

      if (isNaN(number) || number == null) return '0';

      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsStr = parts[1] ? decimal + parts[1] : '';
      return dollars + centsStr;
    }

    var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return moneyFormat;

    var value;
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /**
   * Get optimized Shopify CDN image URL
   */
  function optimizeImageUrl(url, width) {
    if (!url) return '';
    var separator = url.indexOf('?') !== -1 ? '&' : '?';
    return url + separator + 'width=' + width;
  }

  /**
   * Build variant-selector popup HTML for a recommendation card.
   * Mirrors the structure in snippets/variant-selector-popup.liquid.
   */
  function renderVariantPopup(product) {
    if (!product.variants || product.variants.length === 0) return '';

    // Try to find the "Size" option
    var sizeOptionIndex = -1;
    if (product.options) {
      for (var i = 0; i < product.options.length; i++) {
        var name = (product.options[i].name || product.options[i] || '').toString().toLowerCase();
        if (name === 'size') {
          sizeOptionIndex = i;
          break;
        }
      }
    }

    var optionsHtml = '';

    if (sizeOptionIndex !== -1) {
      // Collect unique size values in order
      var seenSizes = {};
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var optionKey = 'option' + (sizeOptionIndex + 1);
        var sizeVal = v[optionKey];
        if (!sizeVal || seenSizes[sizeVal]) continue;
        seenSizes[sizeVal] = true;

        // Check if ANY variant with this size value is available
        var isAvailable = false;
        for (var j = 0; j < product.variants.length; j++) {
          if (product.variants[j][optionKey] === sizeVal && product.variants[j].available) {
            isAvailable = true;
            break;
          }
        }

        // Find the first variant with this size (prefer available)
        var variantId = v.id;
        for (var j = 0; j < product.variants.length; j++) {
          if (product.variants[j][optionKey] === sizeVal && product.variants[j].available) {
            variantId = product.variants[j].id;
            break;
          }
        }

        var disabledClass = isAvailable ? '' : ' variant-popup-option--unavailable';
        var disabledAttr = isAvailable ? '' : ' disabled';
        optionsHtml +=
          '<button class="variant-popup-option' + disabledClass + '"' +
          ' data-variant-id="' + variantId + '"' +
          ' data-product-id="' + product.id + '"' +
          disabledAttr + '>' +
          sizeVal +
          '</button>';
      }
    } else {
      // Fallback: show all variant titles
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var disabledClass = v.available ? '' : ' variant-popup-option--unavailable';
        var disabledAttr = v.available ? '' : ' disabled';
        optionsHtml +=
          '<button class="variant-popup-option' + disabledClass + '"' +
          ' data-variant-id="' + v.id + '"' +
          ' data-product-id="' + product.id + '"' +
          disabledAttr + '>' +
          v.title +
          '</button>';
      }
    }

    return (
      '<div class="variant-selector-popup" id="cart-variant-popup-' + product.id + '" data-product-id="' + product.id + '">' +
        '<div class="variant-popup-content">' +
          '<div class="variant-popup-header">' +
            '<h3>CHOOSE YOUR SIZE</h3>' +
            '<button class="variant-popup-close" data-product-id="' + product.id + '" type="button" aria-label="Close">' +
              '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg>' +
            '</button>' +
          '</div>' +
          '<div class="variant-popup-options">' +
            optionsHtml +
          '</div>' +
          // Add size guide button if product has size charts
          (product.has_size_chart ?
            '<button type="button" class="variant-popup-size-guide sc-trigger" data-sc-open="' + product.id + '">' +
              'SIZE GUIDE' +
            '</button>' : '') +
        '</div>' +
      '</div>'
    );
  }

  /**
   * Get unique product IDs from the container data attribute
   */
  function getProductIds() {
    var container = document.getElementById(CONTAINER_ID);
    if (!container) return [];
    var ids = container.dataset.productIds || '';
    var arr = ids.split(',').filter(Boolean);
    return Array.from(new Set(arr));
  }

  /**
   * Get set of product IDs currently in cart (for filtering)
   */
  function getCartProductIdSet() {
    var container = document.getElementById(CONTAINER_ID);
    if (!container) return new Set();
    var ids = container.dataset.productIds || '';
    return new Set(ids.split(',').filter(Boolean));
  }

  /**
   * Fetch recommendations for up to 3 product IDs, merge, dedupe, filter
   */
  function fetchRecommendations(productIds) {
    var cartIds = getCartProductIdSet();
    var idsToFetch = productIds.slice(0, 3);

    var fetches = idsToFetch.map(function (id) {
      return fetch('/recommendations/products.json?product_id=' + id + '&limit=' + FETCH_LIMIT + '&intent=related')
        .then(function (r) {
          return r.ok ? r.json() : { products: [] };
        })
        .catch(function () {
          return { products: [] };
        });
    });

    return Promise.all(fetches).then(function (results) {
      var allProducts = [];
      var seenIds = new Set();

      for (var i = 0; i < results.length; i++) {
        var products = results[i].products || [];
        for (var j = 0; j < products.length; j++) {
          var product = products[j];
          if (cartIds.has(String(product.id))) continue;
          if (seenIds.has(product.id)) continue;
          if (!product.available) continue;

          var hasAvailableVariant = false;
          if (product.variants) {
            for (var k = 0; k < product.variants.length; k++) {
              if (product.variants[k].available) {
                hasAvailableVariant = true;
                break;
              }
            }
          }
          if (!hasAvailableVariant) continue;

          seenIds.add(product.id);
          allProducts.push(product);

          if (allProducts.length >= MAX_PRODUCTS) break;
        }
        if (allProducts.length >= MAX_PRODUCTS) break;
      }

      return allProducts;
    });
  }

  /**
   * Fetch badge metafield data for products via Section Rendering API
   */
  function fetchBadgeData(products) {
    var badgeMap = {};
    var fetches = products.map(function (product) {
      if (cachedBadgeData[product.id]) {
        badgeMap[product.id] = cachedBadgeData[product.id];
        return Promise.resolve();
      }
      return fetch('/products/' + product.handle + '?section_id=product-badge-data')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var match = html.match(/data-product-badge-data[^>]*>([\s\S]*?)<\/script>/);
          if (match) {
            try {
              var keys = JSON.parse(match[1]);
              badgeMap[product.id] = keys;
              cachedBadgeData[product.id] = keys;
            } catch (e) { /* ignore */ }
          }
        })
        .catch(function () { /* ignore */ });
    });
    return Promise.all(fetches).then(function () { return badgeMap; });
  }

  /**
   * Render a product card matching PDP product-card UI
   */
  function renderCard(product, moneyFormat, badgeKeys) {
    var variant = null;
    if (product.variants) {
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) {
          variant = product.variants[i];
          break;
        }
      }
    }
    if (!variant) variant = product.variants ? product.variants[0] : null;

    var price = variant ? variant.price : product.price;
    var compareAt = variant ? variant.compare_at_price : product.compare_at_price;
    var variantId = variant ? variant.id : null;
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var imageUrl = typeof image === 'string' ? image : (image && image.src ? image.src : '');
    var thumbUrl = optimizeImageUrl(imageUrl, 400);
    var title = product.title.replace(/"/g, '&quot;').replace(/</g, '&lt;');
    var isOnSale = compareAt && parseFloat(compareAt) > parseFloat(price);
    var isSoldOut = !product.available;

    // --- Badges (priority: sold out > discount > metafield) ---
    var badgesHtml = '';
    var keys = badgeKeys || [];

    if (isSoldOut) {
      badgesHtml = '<div class="cart-reco__badge-soldout">SOLD OUT</div>';
    } else if (isOnSale) {
      var discount = Math.round(((parseFloat(compareAt) - parseFloat(price)) / parseFloat(compareAt)) * 100);
      if (discount > 0) {
        badgesHtml = '<div class="cart-reco__badge-discount">-' + discount + '% OFF</div>';
      }
    } else if (keys.indexOf('bestseller') !== -1) {
      badgesHtml = '<div class="cart-reco__badge-discount">BESTSELLER</div>';
    } else if (keys.indexOf('back_in_stock') !== -1) {
      badgesHtml = '<div class="cart-reco__badge-discount">BACK IN STOCK</div>';
    }

    // --- Price ---
    var priceHtml = '';
    if (isOnSale) {
      priceHtml =
        '<div class="cart-reco__price-wrapper">' +
        '<s class="cart-reco__compare-price">MRP ' + formatMoney(compareAt, moneyFormat) + '</s>' +
        '<span class="cart-reco__sale-price">' + formatMoney(price, moneyFormat) + '</span>' +
        '</div>';
    } else {
      priceHtml =
        '<div class="cart-reco__price-wrapper">' +
        '<span class="cart-reco__regular-price">' + formatMoney(price, moneyFormat) + '</span>' +
        '</div>';
    }

    // --- Tax info ---
    var taxHtml =
      '<div class="cart-reco__tax-info">' +
      '<span class="cart-reco__tax-inclusive">INCLUSIVE OF ALL TAXES</span>' +
      '<span class="cart-reco__tax-gst">GST BENEFIT INCLUDED</span>' +
      '</div>';

    // --- Quick add button (opens variant popup) ---
    var quickAddHtml = '';
    if (!isSoldOut) {
      quickAddHtml =
        '<button class="cart-reco__quick-add" data-popup-target="cart-variant-popup-' + product.id + '" type="button" aria-label="Quick add">' +
        '<span class="cart-reco__quick-add-icon">+</span>' +
        '</button>';
    }

    // --- Variant popup ---
    var popupHtml = !isSoldOut ? renderVariantPopup(product) : '';

    return (
      '<div class="cart-reco__card">' +
      '<a href="' + product.url + '" class="cart-reco__image-wrap">' +
      '<img src="' + thumbUrl + '" alt="' + title + '" class="cart-reco__image" loading="lazy">' +
      badgesHtml +
      quickAddHtml +
      popupHtml +
      '</a>' +
      '<div class="cart-reco__details">' +
      '<a href="' + product.url + '" class="cart-reco__title">' + product.title + '</a>' +
      priceHtml +
      taxHtml +
      '</div>' +
      '</div>'
    );
  }

  /**
   * Handle quick-add click
   */
  function onQuickAdd(e) {
    e.preventDefault();
    e.stopPropagation();
    var btn = e.currentTarget;
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    btn.disabled = true;
    var icon = btn.querySelector('.cart-reco__quick-add-icon');
    if (icon) icon.textContent = '...';

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: sectionIds.join(','),
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          btn.disabled = false;
          if (icon) icon.textContent = '+';
          return;
        }
        if (icon) icon.textContent = '\u2713';
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: 'cart-drawer-recommendations',
              data: { source: 'cart-drawer-recommendations', sections: data.sections || {} },
            },
          })
        );
        btn.disabled = false;
        if (icon) icon.textContent = '+';
      })
      .catch(function () {
        btn.disabled = false;
        if (icon) icon.textContent = '+';
      });
  }

  /**
   * Open a variant popup (mobile tap on "+")
   */
  function onPopupOpen(e) {
    e.preventDefault();
    e.stopPropagation();
    var btn = e.currentTarget;
    var popupId = btn.dataset.popupTarget;
    if (!popupId) return;
    var popup = document.getElementById(popupId);
    if (popup) popup.style.display = 'block';
  }

  /**
   * Close a variant popup
   */
  function onPopupClose(e) {
    e.preventDefault();
    e.stopPropagation();
    var productId = e.currentTarget.dataset.productId;
    var popup = document.getElementById('cart-variant-popup-' + productId);
    if (popup) popup.style.display = 'none';
  }

  /**
   * Handle variant selection inside the cart-drawer popup
   */
  function onCartVariantSelect(e) {
    e.preventDefault();
    e.stopPropagation();
    var btn = e.currentTarget;
    var variantId = btn.dataset.variantId;
    var productId = btn.dataset.productId;
    if (!variantId || btn.disabled) return;

    // Visual feedback
    var siblings = btn.parentElement.querySelectorAll('.variant-popup-option');
    for (var i = 0; i < siblings.length; i++) {
      siblings[i].classList.remove('selected');
    }
    btn.classList.add('selected');

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: sectionIds.join(','),
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) return; // error from Shopify

        // Close popup
        var popup = document.getElementById('cart-variant-popup-' + productId);
        if (popup) popup.style.display = 'none';

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: 'cart-drawer-recommendations',
              data: { source: 'cart-drawer-recommendations', sections: data.sections || {} },
            },
          })
        );

      })
      .catch(function (err) {
        console.error('Cart variant add error:', err);
      });
  }

  /**
   * Render recommendations into the container
   */
  function render(products, badgeMap) {
    var container = document.getElementById(CONTAINER_ID);
    if (!container) return;

    var moneyFormat = container.dataset.moneyFormat || '${{amount}}';

    if (!products || products.length === 0) {
      container.innerHTML = '';
      container.style.display = 'none';
      return;
    }

    container.style.display = '';
    var cardsHtml = '';
    for (var i = 0; i < products.length; i++) {
      var keys = badgeMap ? badgeMap[products[i].id] || [] : [];
      cardsHtml += renderCard(products[i], moneyFormat, keys);
    }

    container.innerHTML =
      '<div class="cart-reco__heading">YOU MAY ALSO LIKE</div>' +
      '<div class="cart-reco__scroll">' +
      cardsHtml +
      '</div>';

    // Attach popup-open handlers (mobile "+" buttons)
    var openBtns = container.querySelectorAll('.cart-reco__quick-add');
    for (var i = 0; i < openBtns.length; i++) {
      openBtns[i].addEventListener('click', onPopupOpen);
    }

    // Attach popup-close handlers
    var closeBtns = container.querySelectorAll('.variant-popup-close');
    for (var i = 0; i < closeBtns.length; i++) {
      closeBtns[i].addEventListener('click', onPopupClose);
    }

    // Attach variant-select handlers
    var optionBtns = container.querySelectorAll('.variant-popup-option');
    for (var i = 0; i < optionBtns.length; i++) {
      optionBtns[i].addEventListener('click', onCartVariantSelect);
    }
  }

  /**
   * Render shimmer skeleton placeholders while loading
   */
  function renderShimmer() {
    var container = document.getElementById(CONTAINER_ID);
    if (!container) return;

    container.style.display = '';
    var cards = '';
    for (var i = 0; i < 4; i++) {
      cards +=
        '<div class="cart-reco__card cart-reco__shimmer-card">' +
          '<div class="cart-reco__shimmer cart-reco__shimmer-image"></div>' +
          '<div class="cart-reco__shimmer-details">' +
            '<div class="cart-reco__shimmer cart-reco__shimmer-title"></div>' +
            '<div class="cart-reco__shimmer cart-reco__shimmer-price"></div>' +
            '<div class="cart-reco__shimmer cart-reco__shimmer-tax"></div>' +
          '</div>' +
        '</div>';
    }

    container.innerHTML =
      '<div class="cart-reco__heading cart-reco__shimmer cart-reco__shimmer-heading"></div>' +
      '<div class="cart-reco__scroll">' + cards + '</div>';
  }

  /**
   * Main load function
   */
  function loadRecommendations() {
    var productIds = getProductIds();
    var currentIds = productIds.join(',');

    if (productIds.length === 0) {
      render([]);
      return;
    }

    if (currentIds === lastProductIds && cachedProducts.length > 0) {
      render(cachedProducts, cachedBadgeData);
      return;
    }

    if (isLoading) return;
    isLoading = true;
    lastProductIds = currentIds;

    renderShimmer();

    fetchRecommendations(productIds)
      .then(function (products) {
        cachedProducts = products;
        // Render immediately with cached badge data so cards appear without
        // waiting on the badge metafield round-trip; then refresh once the
        // fresh badge data lands.
        render(products, cachedBadgeData);
        return fetchBadgeData(products).then(function (badgeMap) {
          render(products, badgeMap);
        });
      })
      .catch(function (err) {
        console.error('Cart recommendations error:', err);
      })
      .then(function () {
        isLoading = false;
      });
  }

  /**
   * Watch for cart drawer dialog open via MutationObserver
   */
  function observeDrawer() {
    var dialog = document.querySelector('cart-drawer-component dialog');
    if (!dialog) {
      setTimeout(observeDrawer, 500);
      return;
    }

    if (drawerObserver) return;

    drawerObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'open' && dialog.hasAttribute('open')) {
          loadRecommendations();
          break;
        }
      }
    });

    drawerObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] });

    if (dialog.hasAttribute('open')) {
      loadRecommendations();
    }
  }

  /**
   * Initialize
   */
  function init() {
    observeDrawer();

    document.addEventListener('cart:update', function () {
      lastProductIds = '';
      loadRecommendations();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
